import { getCookie } from './modules/util';

const init = () => {
  let apiBaseUrl = 'https://beta-api.stage.razorpay.in';
  if (location.hostname === 'razorpay.com') {
    apiBaseUrl = 'https://api.razorpay.com';
  }
  let id = getCookie('clientId');
  return { apiBaseUrl, id };
};

const getVariant = (
  id,
  apiBaseUrl,
  experimentId,
  defaultVariant,
  variables,
  trackImpression = true
) => {
  return new Promise((resolve, reject) => {
    try {
      if (!id) {
        throw new Error('[ab]: id cannot be empty');
      }

      if (!experimentId) {
        throw new Error('[ab]: experiment id cannot be empty');
      }

      if (!defaultVariant) {
        throw new Error('[ab]: default variant cannot be empty');
      }

      if (!apiBaseUrl) {
        return defaultVariant;
      }

      const body = {
        id,
        experiment_id: experimentId,
        request_data: JSON.stringify(variables),
        track_impression: trackImpression
      };

      fetch(`${apiBaseUrl}/v1/splitz/evaluate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then(response => response.json())
        .then(data => {
          if (
            !!data.response.variant &&
            data.response.variant.experiment_id == experimentId
          ) {
            return resolve(data.response.variant);
          }
          return resolve(defaultVariant);
        })
        .catch(() => {
          return resolve(defaultVariant);
        });
    } catch (err) {
      return resolve(defaultVariant);
    }
  });
};

export default {
  init,
  getVariant
};
